// src/components/NotFoundPage.js
import React from "react";

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist or has been moved.</p>
    </div>
  );
};

export default NotFoundPage;
